import React from "react"
import { Link } from "gatsby"
import styled from "styled-components"

import Layout from "../components/layout"
import SEO from "../components/seo"
import Section, { ColumnsSection } from '../components/Section';
import LinkButton from '../components/LinkButton';
import { MainTitle, SectionTitle }  from '../components/Titles';
import Activity from '../components/Activity';
import MainImageSection from '../components/MainImageSection';

import { colors } from '../shared/styles';

const MessageSection = styled(Section).attrs(() => ({
  wrapperStyle : {
    height : '100%'
  }
}))`
  height : 100%;
  display : flex;
  flex-direction : column;
  align-items : center;
  justify-content : center;
  padding : 14rem 3rem 5rem 3rem;
`;

const Message = styled.p`
  font-size : 2rem;
  line-height : 2rem;
  letter-spacing : 0.2rem;
  text-align : center;
`

const Message404 = styled(Message)`
  font-size : 6rem;
  font-weight : bolder;
`;

const Page = () => (
  <Layout>
    <SEO title="Mentions Légales" />
    <MessageSection>
      <h1>
        Mentions Légales
      </h1>
      <Message>
        Ce site est édité par Tell Me More SAS, société au capital social de 1000€, RCS&nbsp;851296418.
      </Message>
      <Message>
        La directrice de publication est Mme Delphine Cohen.
      </Message>
      <Message>
        Ce site est hebergé par Netlify, 2325 3rd St #215 San Francisco CA 94107 USA.
      </Message>
      <Message>
        Vous pouvez nous contacter à l'adresse suivante : contact@tmm-agency.fr
      </Message>
    </MessageSection>
  </Layout>
)

export default Page
